import { Injectable } from "@angular/core";
import { HttpHandlerService } from "src/app/core/services/http-handler.service";
import { Config } from "src/app/core/config/api.config";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private http: HttpHandlerService) {}

  getJobOpportunitiesList(query: any) {
    let queryParams = new URLSearchParams();

    for (const key in query) {
      if (query[key] !== null && query[key] !== undefined) {
        queryParams.append(key, query[key]);
      }
    }

    const url = `${
      Config.Job.GetJobOpportunitiesList
    }?${queryParams.toString()}`;

    return this.http.get(url).pipe(map(response => response.data));
  }

  getJobStatistics() {
    return this.http.get(Config.Job.GetJobStatistics).pipe(
      map(response => {
        return response.data;
      })
    );
  }

  getJobApplicantChart(isoDataString: string, noOfApplicant: number) {
    return this.http
      .get(
        Config.Job.GetJobApplicantChart +
          `?ChartStartDate=${isoDataString}&NoOfApplicant=${noOfApplicant}`
      )
      .pipe(
        map(response => {
          return response.data;
        })
      );
  }

  getSpecificNumberOfJobOpportunities(noOfOpportunities: number) {
    return this.http
      .get(
        Config.Job.GetJobOpportunities +
          `?NoOfOpportunities=${noOfOpportunities}`
      )
      .pipe(
        map(response => {
          return response.data;
        })
      );
  }

  getPressReleaseList(pageSize = 10, keyword = "") {
    return this.http
      .get(
        Config.MediaCenter.GetPressReleaseList +
          `?Keyword=${keyword}&PageSize=${pageSize}`
      )
      .pipe(
        map(response => {
          return response.data;
        })
      );
  }

  getOrganization() {
    return this.http.get(Config.Job.GetOrganizations).pipe(
      map(response => {
        return response.data;
      })
    );
  }

  getLookUps(forList: boolean = false) {
    return this.http.get(`${Config.Job.LookUps}?forList=${forList}`).pipe(
      map(response => {
        return response.data;
      })
    );
  }

  getCoordinators() {
    return this.http.get(`${Config.UserManagement.GetCoordinators}`);
  }

  getEventsByStatus(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsByStatus}`, {
       ...filters,
    });
  }
  getEventsByType(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsByType}`, {
      ...filters,
    });
  }
  getEventsSummaryKpis(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsSummaryKpis}`, {
      ...filters,
    });
  }
  getEventsAttendeeStatistics(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsAttendeeStatistics}`, {
      ...filters,
    });
  }
  getEventsUpcomingEvents(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsUpcomingEvents}`, {
      ...filters,
    });
  }
  getEventsApprovalQueue(filters: {
    DateFrom: string;
    DateTo: string;
    OrganizationIds: number[];
  }) {
    return this.http.get(`${Config.Event.GetEventsApprovalQueue}`, {
      ...filters,
    });
  }
}
